module.exports = __webpack_public_path__ + "img/maths-literacy.b032cfa0.svg";